import { combineReducers } from '@reduxjs/toolkit';
import websiteHotels from './WebsiteHotels/slice';
import websiteDestinations from './WebsiteDestinations/slice';

export default combineReducers({
  websiteHotels,
  websiteDestinations,
});
